import {useEffect} from 'react';

import {YandexStoryFormType} from '../../../../../service/yandex-stories/yandex-stories-type';
import {FormInstance} from '../../../../../typings/antd';
import {YANDEX_CONTENT_STEP_WIDTH} from '../../yandex-story-form-helper';

import {YandexStoryFormSlidesContentStep} from './slides-content-step/yandex-story-form-slides-content-step';

type PropsType = {
    formInstance: FormInstance<YandexStoryFormType>;
    formMode: 'create' | 'edit';
    onSubmit: (values: YandexStoryFormType) => Promise<void>;
    onPreviousStep: VoidFunction;
    isFirstStep: boolean;
    onStepActivated: (width: number) => void;
};

export function YandexStoryFormContentStep(props: PropsType): JSX.Element {
    const {formInstance, formMode, onSubmit, onPreviousStep, isFirstStep, onStepActivated} = props;

    useEffect(() => {
        onStepActivated(YANDEX_CONTENT_STEP_WIDTH);
    }, [onStepActivated]);

    return (
        <YandexStoryFormSlidesContentStep
            formInstance={formInstance}
            formMode={formMode}
            isFirstStep={isFirstStep}
            onPreviousStep={onPreviousStep}
            onSubmit={onSubmit}
        />
    );
}
